export const CsrfTokenCookie = 'csrfToken';
export const CsrfTokenHeader = 'Csrf-Token';
export const CsrtTokenQueryParam = 'csrfToken';
export const TokenQueryParam = 'tk';
